/* OSA View — Figma 2881:30849. Same card language as the tables above it:
   white surface, 1px border, 8px radius. */
.wrap {
  background: #fff;
  border: 1px solid var(--border-cell, #eaeaea);
  border-radius: 8px;
  overflow: hidden;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-cell, #eaeaea);
}
.title { margin: 0; font-size: 14px; font-weight: 600; color: var(--header-text, #333843); }
.scope { font-weight: 500; color: var(--header-text-muted, #8f8f91); margin-left: 4px; }

.legend { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.legendItem { display: flex; align-items: center; gap: 6px; font-size: 11px; color: var(--header-text, #333843); }
.legendSep { width: 1px; height: 14px; background: var(--border-cell, #eaeaea); }
.dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.high { background: #34a853; }
.mid  { background: #e8871a; }
.low  { background: #e5484d; }
.none { background: #b9bec7; }
.sizeDot { background: #c9ced8; width: 13px; height: 13px; }

.body { display: grid; grid-template-columns: minmax(0, 1fr) 320px; min-height: 620px; }

.mapPane { position: relative; background: #fafbfc; min-height: 620px; }

.zoom {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid var(--border-cell, #eaeaea);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(16, 18, 27, 0.08);
}
.zoom button {
  width: 34px;
  height: 32px;
  border: 0;
  background: none;
  font-size: 17px;
  line-height: 1;
  color: var(--header-text, #333843);
  cursor: pointer;
}
.zoom button:hover { background: #f5f6f9; }
.zoomSep { width: 1px; height: 18px; background: var(--border-cell, #eaeaea); }

.state { padding: 24px; font-size: 13px; color: var(--header-text-muted, #8f8f91); }

.panel {
  border-left: 1px solid var(--border-cell, #eaeaea);
  padding: 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.panelTitle { margin: 0 0 10px; font-size: 14px; font-weight: 600; color: var(--header-text, #333843); }

.search {
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--header-border, #e0e0e0);
  border-radius: 7px;
  font-size: 12px;
  outline: none;
}
.search:focus { border-color: #7c5cff; }

.sorts { display: flex; gap: 4px; margin: 10px 0 6px; }
.sortBtn {
  padding: 5px 10px;
  border: 0;
  border-radius: 6px;
  background: none;
  font-size: 12px;
  color: var(--header-text-muted, #8f8f91);
  cursor: pointer;
}
.sortBtn:hover { background: #f5f6f9; }
.sortOn { background: #eef1fb; color: var(--header-text, #333843); font-weight: 600; }

/* Scrolls on its own so the map stays put while the list is read. */
.list { flex: 1; overflow-y: auto; max-height: 520px; margin: 0 -6px; padding: 0 6px; }

.card {
  display: block;
  width: 100%;
  padding: 10px 8px;
  border: 0;
  border-bottom: 1px solid var(--border-cell, #f0f0f0);
  background: none;
  text-align: left;
  cursor: pointer;
}
.card:hover { background: #f8f9fb; }
.cardOn { background: #f1efff; }
.cardHead {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--header-text, #333843);
  margin-bottom: 6px;
}
.rows { display: flex; flex-direction: column; gap: 3px; }
.row { display: flex; justify-content: space-between; font-size: 11.5px; color: var(--header-text-muted, #8f8f91); }
.row b { font-weight: 600; color: var(--header-text, #333843); }

@media (max-width: 1180px) {
  .body { grid-template-columns: minmax(0, 1fr); }
  .panel { border-left: 0; border-top: 1px solid var(--border-cell, #eaeaea); }
}
